import React from 'react';
import { Box, Typography } from '@material-ui/core';

const RoleEdit: React.FC = () => {
  return (
    <Box p={3}>
      <Typography variant="h4">Role Edit</Typography>
      <Typography variant="body1">Role Edit component - To be implemented</Typography>
    </Box>
  );
};

export default RoleEdit; 